import capitalize from "lodash/capitalize";
import i18n from "i18n";
const toKey = (value) => value.replace(/[^a-z0-9]+/gi, "_").replace(/^_+|_+$/g, "");
export const unitTypeLabel = (unitType) => i18n.t(`wizard_units.unit_type_labels.${unitType}`, { ns: "aggregation", defaultValue: capitalize(unitType) });
export const unitNameLabel = (unitName) => i18n.t(`wizard_units.unit_labels.${toKey(unitName)}`, { ns: "aggregation", defaultValue: capitalize(unitName) });
